/*
  Rescate de talla agotada — sprint CRO jul-2026 (Bloque A).
  Trabaja con snippets/product-size-rescue.liquid.

  Delegación a nivel documento: escucha los 'change' de los selectores de
  variante ([data-single-option-selector], radios y popouts — ambos disparan
  change con bubbles en este tema) y evalúa la disponibilidad de la variante
  seleccionada contra el JSON embebido en el módulo. Cubre PDP y quick view
  (contenido inyectado por AJAX) sin re-inicialización.
*/
(function () {
  'use strict';

  if (window.__sizeRescueInit) return;
  window.__sizeRescueInit = true;

  var collectionCache = {};

  function getSelectedOptions(form) {
    var selected = {};
    // OJO: form.id NO sirve aqui. HTMLFormElement tiene [LegacyOverrideBuiltIns],
    // asi que el <input type="hidden" name="id"> del form de Shopify SOMBREA la
    // propiedad nativa: form.id devuelve ese input, no el string del atributo.
    // El selector quedaba [form="[object HTMLInputElement]"] -> 0 coincidencias
    // y este modulo llevaba meses auto-ocultandose. Verificado en vivo ago-2026:
    // form.id -> 0 coincidencias / getAttribute('id') -> 6. (gotcha "form.id shadowed")
    var formId = form ? form.getAttribute('id') : null;
    if (!formId) return selected;
    var inputs = document.querySelectorAll('[data-single-option-selector][form="' + formId + '"]');
    inputs.forEach(function (input) {
      var index = input.getAttribute('data-index');
      if (!index) return;
      if (input.type === 'radio') {
        if (input.checked) selected[index] = input.value;
      } else {
        selected[index] = input.value;
      }
    });
    return selected;
  }

  function findVariant(variants, selected) {
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var j = 0; j < variants[i].options.length; j++) {
        var key = 'option' + (j + 1);
        if (selected[key] !== undefined && selected[key] !== variants[i].options[j]) {
          match = false;
          break;
        }
      }
      if (match) return variants[i];
    }
    return null;
  }

  function formatPrice(price) {
    var n = parseFloat(String(price).replace(/,/g, ''));
    if (isNaN(n)) return '';
    var hasCents = Math.round(n * 100) % 100 !== 0;
    return '$' + n.toLocaleString('es-MX', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    });
  }

  function routesRoot() {
    return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  }

  function fetchCollection(handle) {
    if (collectionCache[handle]) return collectionCache[handle];
    // Paginar (250/página) en vez de solo las primeras 100: colecciones grandes de
    // guantes tienen alternativas con stock más allá de la posición 100 que antes
    // nunca se mostraban. Tope de 8 páginas (2000 productos) por seguridad.
    var base = routesRoot() + 'collections/' + handle + '/products.json';
    function page(n, acc) {
      return fetch(base + '?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          // Un 200 sin campo products (proxy/challenge/JSON anómalo) NO es fin
          // de colección: tratarlo como fallo para no cachear una lista
          // truncada como si fuera la colección completa.
          if (!data || !Array.isArray(data.products)) throw new Error('respuesta sin products');
          acc = acc.concat(data.products);
          if (data.products.length === 250 && n < 8) return page(n + 1, acc);
          return acc;
        })
        .catch(function () {
          // Blip de red a media paginación: renderiza con las páginas ya
          // obtenidas (mejor parcial que nada), pero des-cachea para que el
          // próximo cambio de talla reintente la colección completa.
          delete collectionCache[handle];
          return acc;
        });
    }
    collectionCache[handle] = page(1, []);
    return collectionCache[handle];
  }

  function tallaPositionFor(product) {
    if (!product.options) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var name = typeof product.options[i] === 'string' ? product.options[i] : (product.options[i].name || '');
      name = name.toLowerCase();
      if (name.indexOf('talla') !== -1 || name.indexOf('size') !== -1) return i + 1;
    }
    return -1;
  }

  function renderAlternatives(module, talla) {
    var handle = module.getAttribute('data-collection-handle');
    var altsBox = module.querySelector('[data-rescue-alts]');
    var grid = module.querySelector('[data-rescue-grid]');
    if (!handle || !altsBox || !grid) return;

    var requestedTalla = talla;
    // Mostrar de inmediato con skeleton (grid vacío reserva altura vía CSS)
    // para que el relleno asíncrono no genere layout shift tardío
    module.querySelectorAll('[data-rescue-size-alt]').forEach(function (el) {
      el.textContent = requestedTalla;
    });
    grid.textContent = '';
    altsBox.hidden = false;

    fetchCollection(handle).then(function (products) {
      // El cliente pudo cambiar de talla mientras cargaba el fetch
      if (module.getAttribute('data-current-talla') !== requestedTalla) return;

      var ownId = parseInt(module.getAttribute('data-product-id'), 10);
      var matches = [];

      for (var i = 0; i < products.length && matches.length < 4; i++) {
        var p = products[i];
        if (p.id === ownId) continue;
        var pos = tallaPositionFor(p);
        if (pos === -1) continue;
        for (var k = 0; k < p.variants.length; k++) {
          var v = p.variants[k];
          if (v['option' + pos] === requestedTalla && v.available) {
            matches.push({ product: p, variant: v });
            break;
          }
        }
      }

      grid.textContent = '';
      if (!matches.length) {
        altsBox.hidden = true;
        return;
      }

      matches.forEach(function (m) {
        var card = document.createElement('a');
        card.className = 'size-rescue__card';
        card.href = '/products/' + m.product.handle + '?variant=' + m.variant.id;

        // La miniatura envuelve imagen + sello de talla (el sello va absoluto
        // sobre el tile). Se crea siempre, aunque el producto no traiga foto:
        // el sello es la informacion que de verdad importa aqui.
        var thumb = document.createElement('span');
        thumb.className = 'size-rescue__thumb';

        if (m.product.images && m.product.images.length) {
          var img = document.createElement('img');
          var src = m.product.images[0].src;
          img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=360';
          img.alt = m.product.title;
          img.loading = 'lazy';
          img.width = 360;
          img.height = 360;
          thumb.appendChild(img);
        }

        var chip = document.createElement('span');
        chip.className = 'size-rescue__chip';
        chip.textContent = 'Talla ' + requestedTalla;
        thumb.appendChild(chip);
        card.appendChild(thumb);

        var title = document.createElement('span');
        title.className = 'size-rescue__card-title';
        // Las 4 alternativas salen de la misma coleccion, asi que todas empiezan
        // con "Guantes de Portero": repetirlo 4 veces se come las dos lineas de
        // titulo y no aporta nada. Se muestra solo el modelo.
        title.textContent = m.product.title.replace(/^guantes\s+de\s+portero\s+/i, '');
        card.appendChild(title);

        var price = document.createElement('span');
        price.className = 'size-rescue__card-price';
        price.textContent = formatPrice(m.variant.price);
        card.appendChild(price);

        grid.appendChild(card);
      });

      altsBox.hidden = false;
    });
  }

  function update(module) {
    // Auditoría sep-2026 #24: el módulo ya no vive dentro del <form> (está junto al
    // fieldset de Talla); se enlaza por data-form-id, con closest('form') de respaldo.
    var form = document.getElementById(module.getAttribute('data-form-id') || '') || module.closest('form');
    if (!form) return;

    var jsonEl = module.querySelector('[data-rescue-variants]');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var selected = getSelectedOptions(form);
    var variant = findVariant(variants, selected);
    var tallaIndex = module.getAttribute('data-talla-index');
    var talla = selected[tallaIndex];

    if (!talla || !variant || variant.available) {
      module.hidden = true;
      module.removeAttribute('data-current-talla');
      module.__ukUnavailableKey = '';
      return;
    }

    if (module.__ukUnavailableKey !== String(variant.id)) {
      module.__ukUnavailableKey = String(variant.id);
      if (typeof window.ukTrack === 'function') window.ukTrack('size_unavailable', {source:'size-rescue',size:String(talla),variant_id:String(variant.id),product_id:module.getAttribute('data-product-id')});
    }
    module.setAttribute('data-current-talla', talla);
    module.querySelectorAll('[data-rescue-size]').forEach(function (el) {
      el.textContent = talla;
    });

    var wa = module.querySelector('[data-rescue-whatsapp]');
    if (wa) {
      var phone = module.getAttribute('data-whatsapp');
      var text = 'Hola! Me interesa el "' + module.getAttribute('data-product-title') + '" en talla ' + talla + '. ¿Cuándo les llega? 🧤';
      wa.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
    }

    module.hidden = false;
    renderAlternatives(module, talla);
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('[data-single-option-selector]')) return;
    var formId = target.getAttribute('form');
    if (!formId) return;
    var form = document.getElementById(formId);
    if (!form) return;
    var esc = window.CSS && CSS.escape ? CSS.escape(formId) : formId.replace(/["\\]/g, '\\$&');
    var module = document.querySelector('[data-size-rescue][data-form-id="' + esc + '"]') || form.querySelector('[data-size-rescue]');
    if (!module) return;
    // Debounce corto POR MÓDULO (un timer global dejaría stale al form vecino
    // cuando PDP y quick view conviven): los popouts disparan varios change
    if (module.__rescueTimer) clearTimeout(module.__rescueTimer);
    module.__rescueTimer = setTimeout(function () { update(module); }, 60);
  });

  function init() {
    document.querySelectorAll('[data-size-rescue]').forEach(update);
  }

  // Los quick view inyectan el módulo por AJAX después del load, a veces con
  // una talla agotada ya preseleccionada (?variant= desde swatch sold-out):
  // evaluarlo en cuanto aparece en el DOM, no solo en DOMContentLoaded
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mut) {
      mut.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-size-rescue]')) {
          update(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('[data-size-rescue]').forEach(update);
        }
      });
    });
  });

  function start() {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
